import {
  DisablePaypalIntegrationRequestParams,
  DisablePaypalIntegrationResponse,
  FetchPaypalOnboardingLinkRequestParams,
  FetchPaypalOnboardingLinkResponse,
  FetchShorePayOnlineOnboardingLinkRequestParams,
  FetchShorePayOnlineOnboardingLinkResponse,
} from '../types';

export async function fetchPaypalOnboardingLink({
  apiClient,
  merchantId,
}: FetchPaypalOnboardingLinkRequestParams): Promise<FetchPaypalOnboardingLinkResponse> {
  const payload = { merchant: { id: merchantId } };
  return apiClient.payPal.signupLink.create(payload);
}

export async function disablePaypalIntegration({
  apiClient,
  merchantId,
}: DisablePaypalIntegrationRequestParams): Promise<DisablePaypalIntegrationResponse> {
  const payload = { merchant: { id: merchantId } };
  return apiClient.payPal.deactivate.create(payload);
}

export async function fetchShorePayOnlineOnboardingLink({
  apiClient,
  company,
  taxId,
  merchantId,
}: FetchShorePayOnlineOnboardingLinkRequestParams): Promise<FetchShorePayOnlineOnboardingLinkResponse> {
  const payload = {
    source: company,
    merchant_id: merchantId,
    ...(taxId && { tax_number: taxId }),
  };
  return apiClient.shorepayV1.initiateAccountCreation(payload);
}
